module.exports = __webpack_public_path__ + "img/bg-login.6b50fe2f.jpg";